export const PKI = process.env.REACT_APP_PKI  
export const ENCRYPTED_KEY = process.env.REACT_APP_ENCRYPTED_KEY
export const BASE_URL = process.env.REACT_APP_BASE_URL
export const PROJECT_GROUP = process.env.REACT_APP_PROJECT_GROUP
